import React, { FC } from 'react';
import { FormLabel } from 'react-bootstrap';
import { checkTranslation } from '../../../../utilities/FunctionUtilities';
import { useIntl } from 'react-intl';

export interface Props {
  hidden?: boolean;
  textColor?: string;
  required?: boolean;
  label: string;
}

const Label: FC<Props> = ({ hidden, textColor, required, label }: Props) => {
  const intl = useIntl();
  if (!hidden) {
    return (
      <FormLabel className="input-label" style={{ color: textColor }} data-testid="input-label">
        <span>{checkTranslation(label, intl)}</span>
        {required ? <span style={{ color: 'red', marginLeft: 4 }}>*</span> : ''}
      </FormLabel>
    );
  }
  return null;
};

export default Label;
